import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubscribedMap } from "../../../Pages/SubscribedMap/ISubscribed";

export const ListSubscribedMapSlice = createSlice({
  name: "ListSubscribedMapSlice",
  initialState: {} as IReduxState<ISubscribedMap[]>,
  reducers: {
    listSubscribedMap: (state) => {
      state.isLoading = true;
    },
    successlistSubscribedMap: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistSubscribedMap: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistSubscribedMap,
  listSubscribedMap,
  successlistSubscribedMap,
} = ListSubscribedMapSlice.actions;

export default ListSubscribedMapSlice.reducer;
